import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    value: {
        selectedSettingsPage: number;
        configData: any;
        onboardingData: any;
        termsAndConditionsData: any;
        configUpdateButtonLoading: boolean;
        onboardingUpdateButtonLoading: boolean;
        adminChecking: boolean;
        statisticsData: any;
        allData: any;
        meetWithDietitianData: any;
    }
};

const initialState = {
    value: {
        selectedSettingsPage: 1,
        configData: null,
        onboardingData: null,
        termsAndConditionsData: null,
        configUpdateButtonLoading: false,
        onboardingUpdateButtonLoading: false,
        adminChecking: true,
        statisticsData: null,
        allData: null,
        meetWithDietitianData: null,
    }
} as InitialState;

export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setSelectedSettingsPage: (state, action) => {
            state.value.selectedSettingsPage = action.payload;
        },
        setConfigData: (state, action) => {
            state.value.configData = action.payload;
        },
        setOnboardingData: (state, action) => {
            state.value.onboardingData = action.payload;
        },
        setTermsAndConditionsData: (state, action) => {
            state.value.termsAndConditionsData = action.payload;
        },
        setConfigUpdateButtonLoading: (state, action) => {
            state.value.configUpdateButtonLoading = action.payload
        },
        setAdminChecking: (state, action) => {
            state.value.adminChecking = action.payload
        },
        setOnboardingUpdateButtonLoading: (state, action) => {
            state.value.onboardingUpdateButtonLoading = action.payload
        },
        setStatisticsData: (state, action) => {
            state.value.statisticsData = action.payload
        },
        setAllData: (state, action) => {
            state.value.allData = action.payload
        },
        setMeetWithDietitianData: (state, action) => {
            state.value.meetWithDietitianData = action.payload
        },
        updateTermsAndConditionsData: (state, action) => {
            state.value.termsAndConditionsData = action.payload
        },
    },
});

export const {
    setSelectedSettingsPage,
    setConfigData,
    setOnboardingData,
    setTermsAndConditionsData,
    setConfigUpdateButtonLoading,
    setAdminChecking,
    setOnboardingUpdateButtonLoading,
    setStatisticsData,
    setAllData,
    setMeetWithDietitianData,
    updateTermsAndConditionsData,
} = settingsSlice.actions;
export default settingsSlice.reducer;